export class VehicleRequestDto {
  license?: string;
  company: string;
  licenseCountry?: string;
  fleet?: string;

  constructor(license: string, company: string, licenseCountry?: string) {
    this.license = license;
    this.licenseCountry = licenseCountry;
    this.company = company;
  }
}
